import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'ngx-spinner',
  template: `
    <div class="spinner-container">
      <div class="spinner-content">
        <span
          class="spinner-border text-primary"
          style="width: 2.5rem; height: 2.5rem;"
        ></span>
        <span *ngIf="message" class="spinner-message">{{ message() }}</span>
      </div>
    </div>
  `,
  styles: [
    `
      .spinner-container {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(237, 240, 245, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
      }

      .spinner-content {
        display: flex;
        align-items: center;
      }

      .spinner-icon-container i {
        font-size: 35px;
        color: #36f;
      }

      .text-primary {
        color: var(--primary-color) !important;
      }

      .spinner-message {
        margin-left: 10px;
        display: inline-block;
        color: black;
        font-size: 14px;
        font-weight: normal;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  /**
   * Loading text that is shown near the icon
   * @type string
   */
  message: InputSignal<string> = input<string>('Carregando ...');
}
